import * as AuthTypes from "../types/auth.types";

export type EmployeeClientType = {
  id: string;
  first_name: string;
  company_name: string;
};

export interface IEmployeeProfile {
  first_name: string;
  last_name: string;
  address: string;
  phone: string;
}

export interface IClientProfile {
  first_name: string;
  last_name: string;
  address: string;
  phone: string;
}

export type authStateType = {
  userData: any | null;
  authenticated: boolean;
  authenticated_invitation: boolean;
  accepted: boolean;
  loading: boolean;
  token: string;
  accessToken: string;
  data: any;
  status: string;
  save: boolean;
  role: "ADMIN" | "CLIENT" | "EMPLOYEE" | "STAFF" | "USER";
};
const initialState: authStateType = {
  authenticated: false,
  authenticated_invitation: false,
  accepted: false,
  loading: true,
  save: false,
  accessToken: "",
  data: {},
  status: "",
  role: "USER",
  userData: {},
  token: "",
};

export default function authReducer(state = initialState, action: any) {
  switch (action.type) {
    case AuthTypes.LOADING_AUTHENTICATION:
    case AuthTypes.SIGNING_USER:
      return {
        ...state,
        loading: true,
      };
    case AuthTypes.AUTHENTICATED_INVITATION:
      return {
        authenticated_invitation: true,
        loading: false,
        ...action.payload,
      };
    case AuthTypes.SET_USER:
      return {
        authenticated: true,
        loading: false,
        ...action.payload,
      };
    case AuthTypes.SET_INVITATION:
      return {
        loading: false,
        ...action.payload,
      };
    case AuthTypes.CLEAR_INVITATION:
      return {
        ...state,
        loading: false,
        token: "",
      };
    case AuthTypes.SEND_INVITATION:
      return {
        ...state,
        ...action.payload,
      };

    case AuthTypes.REFRESH_TOKEN:
      return {
        ...state,
        accessToken: action.payload,
      };
    case AuthTypes.AUTHORIZATION_TOKEN_SUCCESS:
      return {
        ...state,
        accepted: true,
      };

    default:
      return state;
  }
}
